<ng-container
  *ngIf="{
    data: data$ | async,
  } as content"
>
  <div class="container-text-and-image">
    <div class="row" [ngClass]="{ inverted: content.data?.config?.isInverted }">
      @if (content.data?.image?.src) {
        <div class="col-img" [style.width]="content.data?.config?.imagePercentWidth || '50%'">
          <!-- <div
            *limitUp="DEVICE_SIZE.TABLET"
            class="container-img"
            [style.background-image]="'url(' + (content.data?.image?.src || '') + ')'"
          ></div>
          <img *smallerThan="DEVICE_SIZE.TABLET" src="{{ content.data?.image?.src }}" alt="{{ content.data?.image?.alt }}" /> -->

          <img src="{{ content.data?.image?.src }}" alt="{{ content.data?.image?.alt }}" />
        </div>
      }

      <div class="col-text">
        <div
          class="text-container"
          [ngClass]="{ 'has-bg': content.data?.config?.textBgColor }"
          [style.background-color]="content.data?.config?.textBgColor"
        >
          <div [innerHTML]="content.data?.htmlText"></div>

          @if (content.data && content.data?.action?.url && content.data?.action?.label) {
            <cx-generic-link
              [url]="content.data.action?.url!"
              [target]="content.data.action?.isExternal ? '_blank' : '_self'"
              [ariaLabel]="content.data.action?.label"
              [attr.title]="content.data.action?.label"
              [class]="'action btn btn-primary'"
            >
              {{ content.data.action?.label }} <span class="icon material-symbols-outlined d-flex"> arrow_forward_ios </span>
            </cx-generic-link>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>
